export async function graphqlCreateUpload({
  endpoint,
  accountId,
  signedId,
  projectId,
  name,
  type,
}: {
  endpoint: string;
  accountId: string | number;
  signedId: string;
  projectId: number;
  name: string;
  type: 'Audio' | 'Video' | 'Pdf' | 'Image' | 'Animation';
}): Promise<{
  status: number;
  data: { [key: string]: any };
}> {
  const [status, response]: [number, Response] = await fetch(
    `${endpoint}/graphql`,
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        // is the cookie totes TOTES required !?!?
        // Cookie: cookie,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      keepalive: true,
      body: JSON.stringify({
        query: `
                      mutation createUpload(
                        $accountId: ID!
                        $signedId: String!
                        $projectId: ID!
                        $name: String!
                        $type: String!
                      ) {
                        uploadCreate(
                          accountId: $accountId
                          signedId: $signedId
                          projectId: $projectId
                          name: $name
                          uploadableType: $type
                        ) {
                          code
                          appCode
                          errors
                          message
                          attributeErrors {
                            name
                            errorMessages
                          }
                          file {
                            id
                            name
                            size
                            updatedAt
                            url
                          }
                          upload {
                            id
                            name
                            metadata

                            uploadable {
                              ... on Video {
                                id
                                cloudflareUid
                                cloudflareReadyToStream
                              }
                            }
                    
                          }
                          message
                        }
                      }
                      `,
        variables: {
          //
          accountId,
          signedId,
          projectId,
          name,
          type,
        },
      }),
    }
  ).then(res => [res.status, res]);

  if (response.status >= 400) {
    throw new Error();
  }

  const data = await response.json();

  return { status, data };
}

const URL_PREFIX = window['chameleon'].CHAMELEON_URL;

export function getEndpoint() {
  return `${URL_PREFIX || 'http://localhost:8000'}`;
}

export function getAccountId() {
  try {
    const url = new URL(window?.top?.location?.href as string);
    const pathParts = url.pathname.split('/').filter(Boolean);

    let accountId = pathParts[pathParts.length - 2]; // needs resolving. only works if our url pattern remains consistent

    return accountId || (window as any).getParams().accountId;
    //
  } catch (err) {
    console.warn(err);
  }
}

export function getSlug() {
  try {
    const url = new URL(window?.top?.location?.href as string);
    const pathParts = url.pathname.split('/').filter(Boolean);

    let slug = pathParts[pathParts.length - 1]; // needs resolving. only works if our url pattern remains consistent

    return slug;
    //
  } catch (err) {
    console.warn(err);
  }
}

export const uploadToD3 = () => {
  const uploadToD3Controller = new AbortController();
  const uploadToD3ControllerSignal = uploadToD3Controller.signal;

  uploadToD3ControllerSignal.addEventListener('abort', () => {
    console.log('upload to D3 aborted!');
  });

  return {
    abort() {
      uploadToD3Controller.abort();
    },
    upload: async function(file, statusCallback): Promise<string> {
      const signedId = (await import('services/doDirectUpload').then(
        ({ doDirectUpload }) => {
          return doDirectUpload(
            file,
            uploadToD3ControllerSignal,
            progressEvent => {
              //
              // console.log(
              //   `${progressEvent.type}: ${progressEvent.loaded} bytes transferred. ${progressEvent.total} bytes total`
              // );

              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );

              statusCallback(percentCompleted);
            }
          );
        }
      )) as string;

      return signedId;
    },
  };
};

export type CreateUpload = {
  endpoint?: string;
  accountId?: string | number;
  projectId?: string | number;
  signedId?: string;
  name?: string;
  file: File;
  type: 'Audio' | 'Video' | 'Pdf' | 'Image' | 'Animation';
  statusCallback: () => void;
};

export async function createUpload({
  endpoint,
  accountId,
  projectId,
  signedId,
  file: inputFile,
  name,
  type,
  statusCallback = () => {},
}: CreateUpload): Promise<{
  status: number;
  data: { file: { [key: string]: any }; upload: { [key: string]: any } | null };
}> {
  //
  const _signedId_ =
    signedId || (await uploadToD3()?.upload(inputFile, statusCallback));

  const variables = {
    endpoint: endpoint || getEndpoint(),
    accountId: accountId || getAccountId(),
    signedId: _signedId_,
    projectId: projectId || (window as any).getParams().projectId,
    name: name || (inputFile as any)?.name,
    type,
  };

  const allVariablesSatisfied = Object.values(variables).every(v => v);

  if (!allVariablesSatisfied) {
    console.warn(allVariablesSatisfied, 'IS MISSING DATA !!!');
  }

  const { status, data } = await graphqlCreateUpload(variables);

  const { file = {}, upload = {} } = data?.data?.uploadCreate || {};

  return { status, data: { file, upload } };
}
